(function () {
  "use strict";

  function quantity(preview) {
    var scope = preview.closest("product-info") || document;
    var input = scope.querySelector('input[name="quantity"]');
    return input ? parseInt(input.value, 10) : 0;
  }

  function money(cents) {
    return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
  }

  function render(preview) {
    var data;
    try {
      data = JSON.parse(preview.previousElementSibling.textContent);
    } catch (e) {
      return;
    }

    var qty = quantity(preview);
    if (!(qty > 1)) {
      preview.hidden = true;
      return;
    }

    var unit = data.base;
    for (var i = 0; i < data.tiers.length; i++) {
      if (data.tiers[i].min_qty <= qty) unit = data.tiers[i].unit;
      else break;
    }

    preview.textContent = money(unit) + " each · " + money(unit * qty) + " total";
    preview.hidden = false;
  }

  function renderAll() {
    document.querySelectorAll("[data-qty-price-preview]").forEach(render);
  }

  document.addEventListener("change", function (e) {
    if (e.target.name === "quantity") renderAll();
  });
  document.addEventListener("input", function (e) {
    if (e.target.name === "quantity") renderAll();
  });
  document.addEventListener("variant:changed", renderAll);

  renderAll();
})();
